/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Filter_Type_AllInputs */



/**
* | output |
* | --- |
* | "All Types" |
*
* @param {Manual_Qc_Filter_Type_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_filter_type_all = /** @type {((inputs?: Manual_Qc_Filter_Type_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Filter_Type_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les types")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Arten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i tipi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все типы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los tipos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのタイプ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todos os tipos")
	return /** @type {LocalizedString} */ ("All Types")
});